import './ScaleDisplay.css';

export default function ScaleDisplay({ value, labelLow, labelHigh }) {
  const percentage = value;

  return (
    <div className="scale-display">
      <div className="scale-display__labels">
        <span className="scale-display__label scale-display__label--low">
          {labelLow}
        </span>
        <span className="scale-display__label scale-display__label--high">
          {labelHigh}
        </span>
      </div>
      <div className="scale-display__track">
        <div 
          className="scale-display__fill"
          style={{ width: `${percentage}%` }}
        />
        <div 
          className="scale-display__marker"
          style={{ left: `${percentage}%` }}
        >
          <span className="scale-display__value">{value}</span>
        </div>
      </div>
    </div>
  );
}
